export function toHoursAndMinutes(totalMinutes) {
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  return `${hours} Jam${minutes > 0 ? ` ${minutes} menit` : ''}`
}
